import { render } from "./SubOfficeAdd.vue?vue&type=template&id=55645680&scoped=true"
import script from "./SubOfficeAdd.vue?vue&type=script&lang=js"
export * from "./SubOfficeAdd.vue?vue&type=script&lang=js"

import "./SubOfficeAdd.vue?vue&type=style&index=0&id=55645680&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55645680"]])

export default __exports__